import { createFileRoute, notFound, useParams } from '@tanstack/react-router'

import { blogPageQueries } from 'lib/queries'

import BlogPost from 'pages/Blog/BlogPost'

export const Route = createFileRoute('/blog/$slug')({
  loader: async ({ params, context }) => {
    let index
    try {
      index = await context.queryClient.ensureQueryData(blogPageQueries.index())
    } catch {
      throw notFound()
    }
    const exists = index.posts?.some((p) => p.slug === params.slug)
    if (!exists) throw notFound()
    return context.queryClient.ensureQueryData(
      blogPageQueries.bySlug(params.slug),
    )
  },
  component: BlogPostRoute,
})

function BlogPostRoute() {
  const { slug } = useParams({ from: '/blog/$slug' })
  return <BlogPost slug={slug} />
}
